import { __awaiter } from "tslib";
import { checkUserDeviceRule, UserDeviceType } from 'pathfinder/rules-engine/targetingRules/userDevice';
import { checkUserLoggedInRule } from 'pathfinder/rules-engine/targetingRules/userLoggedIn';
import { checkUserGeoRule } from 'pathfinder/rules-engine/targetingRules/userGeo';
import { checkMwConfigRule } from 'pathfinder/rules-engine/targetingRules/mwConfig';
import { TargetingType } from 'pathfinder/rules-engine/types';
import { ALL_COUNTRIES, NotificationTypeOfUser } from 'pathfinder/modules/NotificationCMS/interfaces/types';
export const filterByPlatform = ({ notifications }) => __awaiter(void 0, void 0, void 0, function* () {
    const results = [];
    for (const notification of notifications) {
        const lowerCasePlatforms = notification.targeting.platform.map((platform) => platform.toLowerCase());
        for (const platform of lowerCasePlatforms) {
            if (platform === UserDeviceType.Desktop || platform === UserDeviceType.Mobile) {
                const isFulfillingRule = yield checkUserDeviceRule({
                    type: TargetingType.UserDevice,
                    deviceType: platform,
                });
                if (isFulfillingRule) {
                    results.push(notification);
                }
            }
        }
    }
    return results;
});
export const filterByUser = ({ notifications }) => __awaiter(void 0, void 0, void 0, function* () {
    const results = [];
    for (const notification of notifications) {
        for (const type of notification.targeting.userType) {
            const isLoggedIn = type === NotificationTypeOfUser.loggedIn;
            const isFulfillingRule = yield checkUserLoggedInRule({
                type: TargetingType.UserLoggedIn,
                value: isLoggedIn,
            });
            if (isFulfillingRule) {
                results.push(notification);
            }
        }
    }
    return results;
});
export const filterByLocation = ({ notifications }) => __awaiter(void 0, void 0, void 0, function* () {
    const results = [];
    for (const notification of notifications) {
        const { targeting: { location: locations }, } = notification;
        const targetingAllLocations = locations.some((location) => location.toLowerCase() === ALL_COUNTRIES.toLowerCase());
        if (targetingAllLocations) {
            results.push(notification);
        }
        else {
            const isFulfillingRule = yield checkUserGeoRule({
                type: TargetingType.UserGeo,
                country: locations,
            });
            if (isFulfillingRule) {
                results.push(notification);
            }
        }
    }
    return results;
});
export const filterByVerticalAndCommunity = ({ notifications, }) => __awaiter(void 0, void 0, void 0, function* () {
    const results = [];
    for (const notification of notifications) {
        const { targeting: { vertical, wikiCommunity }, } = notification;
        // skip checking targeting if there is no vertical nor community defined
        if (!vertical.length && !wikiCommunity.length) {
            results.push(notification);
            continue;
        }
        let isFulfillingVerticalRule = false;
        let isFulfillingCommunityRule = false;
        if (vertical.length) {
            isFulfillingVerticalRule = yield checkMwConfigRule({
                type: TargetingType.MwConfig,
                property: 'wikiVertical',
                value: vertical.map((v) => v.toLowerCase()),
            });
        }
        if (wikiCommunity.length) {
            isFulfillingCommunityRule = yield checkMwConfigRule({
                type: TargetingType.MwConfig,
                property: 'wgCityId',
                value: notification.targeting.wikiCommunity.map((community) => Number(community.id)),
            });
        }
        // check if at least one of them (vertical or community) match targeting
        if (isFulfillingVerticalRule || isFulfillingCommunityRule) {
            results.push(notification);
        }
    }
    return results;
});
